module.exports = __webpack_public_path__ + "img/border3.319ae515.png";